import { client as clientFunc, IMPERSONATION_HEADER } from "@unbox/api";
import posthog from "posthog-js";
import { getImpersonatedUserId } from "@/lib/impersonation";
import { featureFlagHeaders } from "@/utils/feature-flag-overrides";

export const client = clientFunc(import.meta.env.VITE_API_URL, {
  init: { credentials: "include" },
  fetch: async (input: RequestInfo | URL, init?: RequestInit) => {
    // Add PostHog session ID to request headers
    const sessionId = posthog.get_session_id();
    const headers = new Headers(init?.headers);
    if (sessionId) {
      headers.set("X-PostHog-Session-ID", sessionId);
    }
    const impersonatedUserId = getImpersonatedUserId();
    if (impersonatedUserId) {
      headers.set(IMPERSONATION_HEADER, impersonatedUserId);
    }
    for (const [name, value] of Object.entries(featureFlagHeaders())) {
      headers.set(name, value);
    }

    return fetch(input, {
      ...init,
      headers,
    });
  },
});
